import {connectToStores} from 'epic-alt-utils';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import {LandingPageStore} from '../../stores';
import LandingPageView from '../landingpages/LandingPageView';
import SimpleView from '../simple/SimpleView';

/**
 * DefaultView.
 *
 * Seaches for a landing page or a simple page which are
 * located in /landing-pages/* and /pages/* in the cms
 */

@connectToStores
class DefaultView extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    match: PropTypes.object.isRequired,
    landingPageStore: PropTypes.object,
  };
  static getStores() {
    return [LandingPageStore];
  }
  static getPropsFromStores() {
    return {
      landingPageStore: LandingPageStore.getState(),
    };
  }

  getPageSlug(props) {
    const prop = props || this.props;
    const activeSlug = prop.match.params.slug;
    const parentSlug = prop.match.params.parent ? `${prop.match.params.parent}/` : '';
    return `${parentSlug}${activeSlug}`;
  }

  render() {
    const activeSlug = this.getPageSlug();

    const landingPages = this.props.landingPageStore.pages.pages;
    const landingPage = landingPages[activeSlug];

    if (landingPage) {
      return <LandingPageView {...this.props} />;
    }

    return <SimpleView {...this.props} />;
  }
}

export default withRouter(DefaultView);
